import axios from 'axios'

const state = {
	list: [],
};

const mutations = {
	SET_LIST: (state, list) => {
		state.list = list;
	},
}

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {

	getCalendar(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/calendar/index', payload, options)
			.then((response) => {
				return response
			})
	},

	getModalIntervention(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/calendar/modal/' + payload.interventionId + '/intervention')
			.then((response) => {
				return response
			})
	},

	getModalContract(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/calendar/modal/' + payload.interventionId + '/contract')
			.then((response) => {
				return response
			})
	},

	getModalSite(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/calendar/modal/' + payload.interventionId + '/site')
			.then((response) => {
				return response
			})
	},

	getModalClient(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/calendar/modal/' + payload.interventionId + '/client')
			.then((response) => {
				return response
			})
	},
	
	refreshDay(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/calendar/refresh_day', payload, options)
			.then((response) => {
				return response
			})
	},

	validateDurationIntervention(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/calendar/interventions/validate_duration', payload, options)
			.then((response) => {
				return response
			})
	},

	updateDayInterventions(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/calendar/interventions/day_panel', payload, options)
			.then((response) => {
				return response
			})
	},
	
	transferSelectedInterventions(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/calendar/interventions/transfer', payload, options)
			.then((response) => {
				return response
			})
	},

	transferPanelSelectedInterventions(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/calendar/interventions/transfer_panel', payload, options)
			.then((response) => {
				return response
			})
	},

	addElement(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/calendar/elements', payload, options)
			.then((response) => {
				return response
			})
	},

	deleteElement(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/calendar/elements/' + payload.planningId, payload, options)
			.then((response) => {
				return response
			})
	},

	addAbsence(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/calendar/absence', payload, options)
			.then((response) => {
				return response
			})
	},

}

const getters = {
	list: state => state.list,
};

const calendar = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default calendar;
